/** Case-insensitive match against a fixed list of emails. */
export function isEmailInAllowlist(
  email: string | undefined,
  allowlist: readonly string[],
): boolean {
  if (!email?.trim()) return false;
  const normalized = email.trim().toLowerCase();
  return allowlist.some((e) => e.trim().toLowerCase() === normalized);
}
